import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.parse-int";
import _slicedToArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import { getAction } from '@/api/manage';
import AreaChartTy from '@/components/chart/AreaChartTy';
export default {
  name: 'RedisInfo',
  components: {
    AreaChartTy: AreaChartTy
  },
  data: function data() {
    return {
      loading: true,
      tableLoading: true,
      // 定时器ID
      timer: null,
      // 定时器周期
      millisec: 3000,
      // Key 实时数量
      key: {
        title: 'Redis Key 实时数量（个）',
        dataSource: [],
        y: '数量（个）',
        height: 340,
        min: 0,
        max: 100,
        color: '#FF6987',
        lineSize: 8,
        lineColor: '#DC143C'
      },
      // 内存实时占用情况
      memory: {
        title: 'Redis 内存实时占用情况（KB）',
        dataSource: [],
        y: '内存（KB）',
        min: 0,
        max: 3000,
        height: 340,
        lineSize: 8
      },
      redisInfo: [],
      columns: [{
        title: 'Key',
        align: 'center',
        dataIndex: 'key'
      }, {
        title: 'Description',
        align: 'left',
        dataIndex: 'description'
      }, {
        title: 'Value',
        align: 'center',
        dataIndex: 'value'
      }],
      url: {
        keysSize: '/actuator/redis/keysSize',
        memoryInfo: '/actuator/redis/memoryInfo',
        info: '/actuator/redis/info'
      },
      path: '/monitor/redis/info'
    };
  },
  created: function created() {
    var _this = this;

    this.openTimer();
    this.loadRedisInfo();
    setTimeout(function () {
      _this.loadData();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    this.closeTimer();
  },
  methods: {
    /** 开启定时器 */
    openTimer: function openTimer() {
      var _this2 = this;

      this.loadData();
      this.closeTimer();
      this.timer = setInterval(function () {
        if (_this2.$route.path === _this2.path) {
          _this2.loadData();
        }
      }, this.millisec);
    },

    /** 关闭定时器 */
    closeTimer: function closeTimer() {
      if (this.timer) clearInterval(this.timer);
    },

    /** 查询数据 */
    loadData: function loadData() {
      var _this3 = this;

      Promise.all([getAction(this.url.keysSize), getAction(this.url.memoryInfo)]).then(function (res) {
        var time = moment().format('hh:mm:ss');

        var _res = _slicedToArray(res, 2),
            currentSize = _res[0].dbSize,
            memoryInfo = _res[1];

        var currentMemory = memoryInfo.used_memory / 1000; // push 数据

        _this3.key.dataSource.push({
          x: time,
          y: currentSize
        });

        _this3.memory.dataSource.push({
          x: time,
          y: currentMemory
        }); // 最大长度为6


        if (_this3.key.dataSource.length > 6) {
          _this3.key.dataSource.splice(0, 1);

          _this3.memory.dataSource.splice(0, 1);
        } // 计算 Key 最大最小值


        var keyPole = _this3.getMaxAndMin(_this3.key.dataSource, 'y');

        _this3.key.max = Math.floor(keyPole[0]) + 10;
        _this3.key.min = Math.floor(keyPole[1]) - 10;
        if (_this3.key.min < 0) _this3.key.min = 0; // 计算 Memory 最大最小值

        var memoryPole = _this3.getMaxAndMin(_this3.memory.dataSource, 'y');

        _this3.memory.max = Math.floor(memoryPole[0]) + 100;
        _this3.memory.min = Math.floor(memoryPole[1]) - 100;
        if (_this3.memory.min < 0) _this3.memory.min = 0;
      }).catch(function (e) {
        console.error(e);

        _this3.closeTimer();

        _this3.$message_custom('获取 Redis 信息失败', 'error');
      }).finally(function () {
        _this3.loading = false;
      });
    },
    // 获取一组数据中最大和最小的值
    getMaxAndMin: function getMaxAndMin(dataSource, field) {
      var maxValue = null,
          minValue = null;
      dataSource.forEach(function (item) {
        var value = Number.parseInt(item[field]); // max

        if (maxValue == null) {
          maxValue = value;
        } else if (value > maxValue) {
          maxValue = value;
        } // min


        if (minValue == null) {
          minValue = value;
        } else if (value < minValue) {
          minValue = value;
        }
      });
      return [maxValue, minValue];
    },
    loadRedisInfo: function loadRedisInfo() {
      var _this4 = this;

      this.tableLoading = true;
      getAction(this.url.info).then(function (res) {
        _this4.redisInfo = res.result;
      }).finally(function () {
        _this4.tableLoading = false;
      });
    }
  }
};